'use client';

import { Map } from 'lucide-react';
import { LoadingAlert } from '@/components/Shared/LoadingAlert';
import { classes } from '@/components/Table/Map';
import { Skeleton } from '@/components/ui/skeleton';
export function TableMapSkeleton() {
  return <div className={classes.wrapper}>
      <Skeleton className="grow bg-secondary" />
      <div className="absolute w-[80%] bottom-[10%] left-[10%] z-10">
        <LoadingAlert icon={<Map color="rgb(0, 30, 113)" className="h-4 w-4" />} title="Fetching map" background />
      </div>
    </div>;
}